import React, { useEffect, useState } from "react";
import { useTranslation } from 'react-i18next';
import { Button } from "../../components/ui/button";
import ModalComponent from "./modal";
import { FaArrowLeft, FaCreditCard } from "react-icons/fa";
import axios from "axios";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { formatNombre, scrollToTop } from "../../lib/utils";
import { payerTransporteur } from "../../lib/apis";
import { toast } from "react-toastify";
import Breadcrumb from "../../components/Breadcrumb";

const PaiementTrans = () => {
  const { t, i18n } = useTranslation();
  const { id: ProposalId } = useParams();
  const navigate = useNavigate()
  const [isModalVisible, setIsModalVisible] = useState(false);
  const commande = useLocation().state
  const [loading, setLoading] = useState(false);
  const token = localStorage.getItem("token");

  useEffect(() => {
    scrollToTop()
  }, [])

  const handleOpenModal = () => {
    setIsModalVisible(true);
  };

  const handleCloseModal = () => {
    setIsModalVisible(false);
  };

  const handlePayment = async () => {
    setLoading(true);


    try {
      const { data } = await axios.get(`${payerTransporteur}/${ProposalId}/accept`,
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      )
      console.log("data", data.paymentUrl);
      // toast.success(t('payment.paymentSuccess'));
      window.open(data.paymentUrl);
      navigate("/quotation_list")
    } catch (error: any) {
      toast.error(i18n.language === 'fr' ? error.response.data.message : error.response.data.message_en)
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="w-full h-full">
      <div className="flex flex-row py-5  m-5  items-center justify-start w-full ">
        <FaArrowLeft
          onClick={() => navigate(-1)}
          className="  text-green-500 text-3xl"
          style={{ cursor: "pointer" }}
        />
        <Breadcrumb />
      </div>
      <div className="h-[100px] flex items-center justify-center text-2xl">
        {t('payment.transportFees')}
      </div>

      <div className="">
        {/* <div className="col-span-3">
          <div className="bg-white p-6 shadow-lg rounded-lg h-[300px]">
            <div className="flex flex-col items-start justify-start">
              <div className="text-2xl mt-2">{t('payment.paymentService')}</div>
              <div className="text-xl my-3">{t('payment.choosePaymentMethod')}</div>
              <div className="flex items-center justify-between mb-4 gap-4">
                <div className="flex flex-col items-center mr-4">
                  <FaCreditCard className="text-xl text-gray-500" />
                  <span className="mt-1 text-xl text-gray-400">
                    {t('payment.creditCard')}
                  </span>
                  <input
                    type="radio"
                    name="payment"
                    value="Card"
                    onChange={() => setPaymentMethod("Card")}
                  />
                </div>
                <label className="flex flex-col items-center space-x-4 mr-4">
                  <input
                    type="radio"
                    name="payment"
                    value="OM"
                    onChange={() => setPaymentMethod("OM")}
                  />
                  <span className="text-sm text-gray-400">OM</span>
                </label>
                <label className="flex flex-col items-center space-x-4 mr-4">
                  <input
                    type="radio"
                    name="payment"
                    value="MOMO"
                    onChange={() => setPaymentMethod("MOMO")}
                  />
                  <span className="text-sm text-gray-400">MOMO</span>
                </label>
              </div>

              {paymentMethod === "Card" && (
                <div className="space-y-4">
                  <input
                    type="text"
                    placeholder={t('payment.cardNumberPlaceholder')}
                    className="w-full p-2 border rounded-lg"
                    value={cardNumber}
                    onChange={(e) => setCardNumber(e.target.value)}
                  />
                  <div className="flex space-x-4">
                    <input
                      type="text"
                      placeholder={t('payment.expiryPlaceholder')}
                      className="w-1/2 p-2 border rounded-lg"
                      value={cardExpiry}
                      onChange={(e) => setCardExpiry(e.target.value)}
                    />
                    <input
                      type="text"
                      placeholder={t('payment.cvvPlaceholder')}
                      className="w-1/2 p-2 border rounded-lg"
                      value={cardCVC}
                      onChange={(e) => setCardCVC(e.target.value)}
                    />
                  </div>
                </div>
              )}

              {(paymentMethod === "OM" || paymentMethod === "MOMO") && (
                <input
                  type="text"
                  placeholder={t('payment.phoneNumberPlaceholder')}
                  className="w-full p-2 border rounded-lg"
                  value={phoneNumber}
                  onChange={(e) => setPhoneNumber(e.target.value)}
                />
              )}
            </div>
          </div>
        </div> */}

        <div className="col-span-2">
          <div className="bg-white p-6 shadow-lg rounded-lg h-[300px]">
            <div className="flex flex-col">
              <div className="my-2 text-2xl">{t('payment.summary')}</div>
              <div className="flex my-2 text-xl gap-2">
                <span className="text-gray-400">{t('transporteur')}:</span>{commande.name}
              </div>
              <div className="text-center border-t border-gray-300 my-2">
                {/* <div className="flex justify-between text-gray-500 my-2">
                  <span>10 sacs 50 kilo Haricots noir</span>
                  <span>25000F</span>
                </div>
                <div className="font-bold flex justify-between">
                  <span>{t('payment.total')}</span>
                  <span>25000F</span>
                </div> */}
                <div className="flex my-4">
                  <span>{t('payment.deliveryPrice')}:</span>
                  <span className="font-bold text-xl ml-5">{formatNombre(commande.price)}F</span>
                </div>
              </div>
              <div className="flex justify-center">
                <Button
                  disabled={loading}
                  className="bg-green-500 text-white p-2 rounded-full w-[80%]"
                  onClick={handlePayment}
                >
                  {loading ? "..." : t('payment.placeTransportOrder')}
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ModalComponent isVisible={isModalVisible} onClose={handleCloseModal} />
    </div>
  );
};

export default PaiementTrans;